import { useEffect, useState } from 'react';

export const useTimer = (totalCounts, lastDriverInstructionTime) => {
    const [timeElapsed, setTimeElapsed] = useState(0);

    // Function to calculate the initial time based on totalCounts and lastDriverInstructionTime
    const calculateInitialTimeElapsed = () => {
        let sumOfCounts = 0;

        if (totalCounts && totalCounts.length > 0) {
            const currentCounts = totalCounts[0];  // Use the first record for today
            sumOfCounts = (currentCounts.work + currentCounts.driving + currentCounts.pause + currentCounts.other) * 60;  // Convert minutes to seconds
        }

        if (lastDriverInstructionTime) {
            const lastInstructionDate = new Date(lastDriverInstructionTime);
            const now = new Date();
            const timeDifferenceSeconds = Math.floor((now - lastInstructionDate) / 1000);  // Difference in seconds
            sumOfCounts += timeDifferenceSeconds;
        }

        return sumOfCounts;
    };

    // Set the initial time when the component loads
    useEffect(() => {
        const initialTime = calculateInitialTimeElapsed();
        setTimeElapsed(initialTime);
        if(initialTime==0)return ;

        // Start the timer and increase the time by 1 second every second
        const timer = setInterval(() => {
            setTimeElapsed((prev) => prev + 1);
        }, 1000);

        return () => clearInterval(timer);  // Cleanup on unmount
    }, [totalCounts, lastDriverInstructionTime]);

    // Convert elapsed time to a formatted string (hh:mm:ss)
    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    return formatTime(timeElapsed);
};
